<template>
  <div>
    <div class="text-center" v-if="loading">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div v-if="tabela && !loading">
      <div>
        <b-table
          responsive="sm"
          :items="dadosInfoBancarias"
          :fields="camposInfoBancarias"
          per-page="1000"
          striped
        >
          <template #cell(options)="data">
            <div class="d-flex justify-content-end">
              <b-button
                size="sm"
                class="me-1"
                variant="primary"
                @click="editarInfoBancarias(data.item)"
                data-tooltip="Editar"
                data-tooltip-location="bottom"
              >
                <i class="mdi mdi-pencil"></i>
              </b-button>
              <b-button
                size="sm"
                class="me-1"
                variant="danger"
                @click="excluirInfoBancarias(data.item)"
                data-tooltip="Excluir"
                data-tooltip-location="bottom"
              >
                <i class="mdi mdi-trash-can"></i>
              </b-button>
            </div>
          </template>
        </b-table>
      </div>
      <div>
        <div class="mt-1 d-flex justify-content-end">
          <b-button variant="info" class="mt-5 mb-3" @click="incluir()">
            <i class="mdi mdi-plus"></i>
            Incluir
          </b-button>
        </div>
      </div>
      <div class="row">
        <div class="mt-1 d-flex justify-content-between">
          <b-button class="mt-1 me-1" @click="navegar('email', false)">
            <i class="mdi mdi-arrow-left-circle font-size-15"></i>
          </b-button>
          <!-- <b-button variant="primary" class="mt-1" @click="navegar('contatos', true)">
            Próximo
          </b-button> -->
        </div>
      </div>
    </div>
    <div v-if="!tabela && !loading">
      <div class="row">
        <h6>
          Apenas contas bancárias de pessoa física são aceitas.
        </h6>
      </div>
      <div class="row">
        <p>
          Caso o seu Banco ou Agência não esteja disponível, entre em contato
          com a Unicampo para efetuar o cadastramento.
        </p>
      </div>
      <div class="row">
        <div class="col-md-6">
          <b-form-group class="mb-3" label="Banco">
            <multiselect
              v-model="selectBanco"
              placeholder="Selecione"
              :show-labels="false"
              :allow-empty="false"
              label="nm_bco"
              :options="optionBanco"
              @input="carregarAgencias"
              :disabled="disabledCampo"
            />
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group class="mb-3" label="Agência">
            <multiselect
              v-model="selectAgencia"
              placeholder="Selecione"
              :show-labels="false"
              :allow-empty="false"
              label="nm_agencia"
              :options="optionAgencia"
              :loading="loadingAgencias"
              :disabled="disabledCampo"
            >
              <span slot="noResult">Selecione um Banco.</span>
              <span slot="noOptions">Selecione um Banco.</span>
            </multiselect>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <b-form-group class="mb-3" label="N° da Conta">
            <b-form-input
              v-model="nrConta"
              trim
              v-mask="'##########'"
              autocomplete="off"
              maxlength="10"
              type="text"
              :disabled="disabledCampo"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-2 d-flex">
          <b-form-group class="mb-3" label="DV">
            <b-form-input
              v-model="dvConta"
              trim
              autocomplete="off"
                :maxlength="dvMaxLength"
              min="0"
              type="text"
              @input="validateValue"
              @blur="$v.dvConta.$touch()"
              :class="{
                'is-invalid': $v.dvConta.$dirty && $v.dvConta.$invalid,
                'is-valid': $v.dvConta.$dirty && !$v.dvConta.$invalid,
              }"
            ></b-form-input>
            <b-form-invalid-feedback v-if="$v.dvConta.$dirty && $v.dvConta.$invalid">
              O campo DV é obrigatório.
            </b-form-invalid-feedback>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group class="mb-3" label="Tipo de Conta">
            <multiselect
              v-model="selectTipoConta"
              placeholder="Selecione"
              :show-labels="false"
              :allow-empty="false"
              label="label"
              :options="optionTipoConta"
              :disabled="disabledCampo"
            />
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div>
            <b-form-checkbox
              id="checkbox-1"
              v-model="stPrincipal"
              :unchecked-value="false"
              :value="true"
              :disabled="disabledPrincipal == true"
              plain
            >
              Conta Bancária Principal
            </b-form-checkbox>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="mt-1 d-flex justify-content-between">
          <b-button
              class="mt-1 me-1"
              @click="tabela = true"
              data-tooltip="Voltar"
              data-tooltip-location="bottom"
          >
            <i class="mdi mdi-arrow-left-circle font-size-15"></i>
          </b-button>
          <b-button
            class="mt-1 me-1"
            variant="success"
            @click="salvar()"
            :disabled="disabledSalvar"
            data-tooltip="Salvar"
            data-tooltip-location="bottom"
          >
            <i class="mdi mdi-content-save"></i>
            <b-spinner
              variant="primary"
              small
              class="ms-2"
              v-if="loadingSalvar"
            ></b-spinner>
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import Multiselect from "vue-multiselect";
import { required } from "vuelidate/lib/validators"; // Importa o validador required

const capitalizeString = (str) => {
  return str
    .split(" ")
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
};

export default {
  components: {
    Multiselect,
  },

  data() {
    return {
      optionBanco: [],
      optionAgencia: [],
      optionTipoConta: [
        {
          tp_conta: "C",
          label: "Conta Corrente",
        }
      ],
      selectBanco: {},
      selectAgencia: {},
      nrConta: "",
      dvConta: "",
      selectTipoConta: {},
      stPrincipal: "",
      disabledPrincipal: "",
      camposInfoBancarias: [
        {
          key: "NMBCO",
          label: "Banco",
          formatter: (value, row, column) => {
            return column.CDBCO + " - " + capitalizeString(value);
          },
        },
        {
          key: "NMAGENCIA",
          label: "Agência",
          formatter: (value, row, column) => {
            return (
              column.NRAGENCIA +
              "-" +
              column.DVAGENCIA +
              " " +
              capitalizeString(value)
            );
          },
        },
        {
          key: "NRCTA",
          label: "Conta",
        },
        {
          key: "DVCTA",
          label: "DV",
        },
        {
          key: "CONTA",
          label: "Tipo de Conta",
        },
        {
          key: "PRINCIPAL",
          label: "Principal",
        },
        {
          key: "options",
          label: "",
        },
      ],
      dadosInfoBancarias: [],
      loading: true,
      tabela: true,
      avancar: null,
      loadingSalvar: false,
      disabledSalvar: false,
      loadingAgencias: false,
      disabledCampo: false,
    };
  },
    computed: {
      dvMaxLength() {
        if (!this.selectBanco || !this.selectBanco.nm_bco) return 1;
        const nomeBanco = this.selectBanco.nm_bco.toLowerCase();
        const bancosPermitidos = [
          "hsbc",
          "citibank",
          "agiplan",
          "agipag"
        ];
        return bancosPermitidos.some(banco => nomeBanco.includes(banco)) ? 2 : 1;
      }
    },

      watch: {
        selectBanco(newBanco) {
          if (!newBanco || !newBanco.nm_bco) {
            this.dvConta = "";
            return;
          }
          const nomeBanco = newBanco.nm_bco.toLowerCase();
          const bancosPermitidos = ["hsbc", "citibank", "agiplan", "agipag"];
          if (!bancosPermitidos.some(banco => nomeBanco.includes(banco))) {
            this.dvConta = "";
          }
        }
      },
  validations: {
    dvConta: {
      required,
    },
  },

  async created() {
    await this.buscarInfoBancarias();
  },

  methods: {
    async buscarInfoBancarias() {
      this.loading = true;
      this.dadosInfoBancarias = [];
      try {
        const [contas, bancos] = await Promise.allSettled([
          this.$http.get("api/profileErp/contas-bancarias"),
          // O portal_api ainda não disponibiliza lookup de bancos/agências.
          // Mantemos o lookup legado somente para viabilizar a seleção da agência.
          this.$http.get("api/cadastroCandidato/buscarLkpBancos"),
        ]);

        if (contas.status !== "fulfilled") {
          throw contas.reason;
        }

        const dadosContas = contas.value.data;
        const listaContas = Array.isArray(dadosContas)
          ? dadosContas
          : dadosContas?.ContasBancarias || dadosContas?.Data || dadosContas?.data || [];
        this.dadosInfoBancarias = listaContas.map(item => ({
          ...item,
          CDBCO: item.CDBCO || item.cdBanco || item.cd_bco || item.cdBco || item.Agencia?.Banco?.Codigo || item.agencia?.banco?.codigo || "",
          NMBCO: item.NMBCO || item.nmBanco || item.nm_bco || item.nmBco || item.Agencia?.Banco?.Nome || item.agencia?.banco?.nome || "",
          NRAGENCIA: item.NRAGENCIA || item.nrAgencia || item.nr_agencia || item.Agencia?.Numero || item.agencia?.numero || "",
          DVAGENCIA: item.DVAGENCIA || item.dvAgencia || item.dv_agencia || item.Agencia?.Digito || item.agencia?.digito || "",
          NMAGENCIA: item.NMAGENCIA || item.nmAgencia || item.nm_agencia || item.Agencia?.Nome || item.agencia?.nome || "",
          NRCTA: item.NRCTA || item.nrConta || item.nr_conta || item.NumeroConta || item.numeroConta || "",
          DVCTA: item.DVCTA || item.dvConta || item.dv_conta || item.DigitoConta || item.digitoConta || "",
          TPCONTA: item.TPCONTA || item.tpConta || item.tp_conta || item.TipoConta || item.tipoConta || "",
          CONTA: item.CONTA || item.tpConta || item.tp_conta || item.TipoConta || item.tipoConta || "C",
          STPRINCIPAL: item.STPRINCIPAL || item.stPrincipal || item.st_principal || item.Principal || item.principal || "",
          PRINCIPAL: item.PRINCIPAL || (item.Principal === "S" || item.principal === "S" || item.stPrincipal === "S" || item.principal === true || item.st_principal === "S" ? "Sim" : "Não"),
          SQINFO_BANCARIA: item.SQINFO_BANCARIA || item.id || item.Id || ""
        }));

        const dadosBancos = bancos.status === "fulfilled" ? bancos.value.data : [];
        const listaBancos = Array.isArray(dadosBancos)
          ? dadosBancos
          : dadosBancos?.Data || dadosBancos?.data || [];
        this.optionBanco = listaBancos.map((item) => {
          return {
            ...item,
            nm_bco: item.cd_bco + " - " + capitalizeString(item.nm_bco || ""),
          };
        });
        if (this.dadosInfoBancarias.length == 0) {
          this.stPrincipal = true;
          this.disabledPrincipal = true;
        } else {
          this.stPrincipal = false;
          this.disabledPrincipal = "";
        }
      } catch (err) {
        this.$tools.alerta(
          err.response?.data?.message || "Não foi possível carregar as informações bancárias.",
          "error"
        );
      } finally {
        this.loading = false;
      }
    },

    async carregarAgencias() {
      this.loadingSalvar = true;
      this.disabledSalvar = true;
      this.selectAgencia = null;
      this.optionAgencia = [];
      this.loadingAgencias = true;
      try {
        const response = await this.$http.get(
          "api/cadastroCandidato/buscarLkpAgencia/" + this.selectBanco.cd_bco
        );
        const dadosAgencias = Array.isArray(response.data)
          ? response.data
          : response.data?.Data || response.data?.data || [];
        this.optionAgencia = dadosAgencias.map((item) => {
          return {
            ...item,
            nm_agencia:
              item.nr_agencia +
              "-" +
              item.dv_agencia +
              " " +
              capitalizeString(item.nm_agencia),
          };
        });
      } catch (err) {
        this.$tools.alerta(
          err.response?.data?.message || "Não foi possível carregar as agências do banco selecionado.",
          "error"
        );
      } finally {
        this.loadingAgencias = false;
        this.loadingSalvar = false;
        this.disabledSalvar = false;
      }
    },

    navegar(nomeAba, direcao) {
      this.$emit("navegar", nomeAba, direcao);
    },

    async salvar() {
      this.$v.$touch();
      this.loadingSalvar = true;
      this.disabledSalvar = true;
      if (
        !this.selectBanco ||
        !this.selectAgencia ||
        !this.nrConta ||
        this.nrConta == null ||
        this.nrConta <= 0 ||
        !this.dvConta ||
        !this.selectTipoConta
      ) {
        this.$tools.alerta(
          "Por favor, para continuar preencha todos os campos",
          "warning"
        );
        this.loadingSalvar = false;
        this.disabledSalvar = false;
        return;
      }

      const payload = {
          IdAgencia: this.selectAgencia.Id || this.selectAgencia.id || this.selectAgencia.sq_agencia || this.selectAgencia.cd_agencia,
          NumeroConta: parseInt(this.nrConta),
          DigitoConta: this.dvConta,
          TipoConta: this.selectTipoConta.tp_conta || this.selectTipoConta.id || this.selectTipoConta.cd_tipo,
          Principal: this.stPrincipal ? "S" : "N",
      };

      const isEdit = !!this.sqInfoBancaria;
      const url = isEdit ? `api/profileErp/contas-bancarias/${this.sqInfoBancaria}` : "api/profileErp/contas-bancarias";
      const requestAction = isEdit ? this.$http.put(url, payload) : this.$http.post(url, payload);

      try {
        await requestAction;
        this.tabela = !this.tabela;
        this.buscarInfoBancarias();
        this.$emit("carregarNivelPerfil");
      } catch (err) {
        this.$tools.alerta(err.response?.data?.message || "Erro ao salvar informação bancária no ERP", "error");
      } finally {
        this.loadingSalvar = false;
        this.disabledSalvar = false;
      }
    },

    incluir() {
      this.disabledCampo = false;
      (this.selectBanco = ""),
        (this.selectAgencia = ""),
        (this.nrConta = ""),
        (this.dvConta = ""),
        (this.selectTipoConta = ""),
        (this.optionAgencia = []),
        (this.tabela = false);
      this.sqInfoBancaria = "";
      if (this.dadosInfoBancarias.length == 0) {
        this.stPrincipal = true;
        this.disabledPrincipal = true;
      } else {
        this.stPrincipal = false;
        this.disabledPrincipal = "";
      }
    },

    async editarInfoBancarias(data) {
      this.disabledCampo = true;
      this.selectBanco = this.optionBanco.find((el) => el.cd_bco == data.CDBCO);
      this.nrConta = data.NRCTA;
      this.dvConta = data.DVCTA;
      this.selectTipoConta = this.optionTipoConta.find(
        (el) => el.tp_conta == data.TPCONTA
      );
      this.stPrincipal = data.STPRINCIPAL == "S" ? true : false;
      this.disabledPrincipal = data.STPRINCIPAL == "S" ? true : false;
      this.sqInfoBancaria = data.SQINFO_BANCARIA;
      this.carregarAgencias().then(() => {
        this.preencherAgencia(data.NRAGENCIA);
      });

      this.tabela = false;
    },

    preencherAgencia(nrAgencia) {
      this.selectAgencia = this.optionAgencia.find(
        (el) => el.nr_agencia == nrAgencia
      );
    },

    async excluirInfoBancarias(data) {
      if (data.STPRINCIPAL === "S" || data.principal === true) {
        this.$tools.alerta(
          "Não é possível excluir uma informação bancária principal",
          "error"
        );
      } else {
        try {
          await this.$http.delete(
            "api/profileErp/contas-bancarias/" + data.SQINFO_BANCARIA
          );
        } catch (err) {
          this.$tools.alerta(err.response?.data?.message || "Erro ao excluir informação bancária no ERP", "error");
        } finally {
          this.buscarInfoBancarias();
        }
      }
    },

    validateValue() {
      if (this.dvConta < 0) {
        this.dvConta = 0;
      }
    },
  },
};
</script>
